<template>
  <MuteButton />
  <ScrollComponent />
  <TitlePage />
  <AboutAKitty />
  <TokenomicsPage />
  <HowBuy />
  <PartnersPage />
  <FooterPage />
</template>

<script>
import AboutAKitty from "./components/AboutAKitty.vue";
import FooterPage from "./components/FooterPage.vue";
import HowBuy from "./components/HowBuy.vue";
import MuteButton from "./components/MuteButton.vue";
import PartnersPage from "./components/PartnersPage.vue";
import ScrollComponent from "./components/ScrollComponent.vue";
import TitlePage from "./components/TitlePage.vue";
import TokenomicsPage from "./components/TokenomicsPage.vue";

export default {
  name: "App",
  components: {
    TitlePage,
    AboutAKitty,
    TokenomicsPage,
    HowBuy,
    FooterPage,
    ScrollComponent,
    MuteButton,
    PartnersPage,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden;
}

.title {
  font-weight: bold;
  font-size: 3rem;
}

.component-header {
  height: 45px;
}
</style>
